"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseState = void 0;
exports.promiseState = {
    pending: 'pending',
    error: 'error',
    success: 'success'
};
